module.exports = __webpack_public_path__ + "img/wash-mark.093191b9.png";